import React, {useContext, useEffect, useRef, useState} from 'react';
import "./certifications.scss";
import { AppContext } from '../../services/translationContext';
import { Link, useParams } from 'react-router-dom';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { IconButton } from '@mui/material';
import { PageHero } from '../../components/page-hero/page-hero';
import SeoHelmet from '../../components/SeoHelmet';

const CertificationCard = ({ cert, keyId }) => {
  const [expanded, setExpanded] = useState(false);
  const [showReadMore, setShowReadMore] = useState(false);
  const contentRef = useRef(null);

  useEffect(() => {
    if (contentRef.current && contentRef.current.scrollHeight > 400) {
      setShowReadMore(true);
    }
  }, []);

  return (
    <div key={keyId} className="col-sm-12 col-lg-4 p-3">
      <div
        className="box-certifications p-3 d-flex flex-column transition-03s-eio"
        style={{
          maxHeight: expanded ? '100%' : '300px',
          overflow: 'hidden',
          position: 'relative',
          transition: 'max-height 0.3s ease',
        }}
      >
        <div ref={contentRef}>
          <div className='row align-items-center'>
            <div className='col-3 pb-2'>
              <img src={cert.logo} className="" style={{display: "flex", width: "100%", height: "auto"}} alt={cert.altImg} />
            </div>
            <div className='col-9 ps-2'>
              <h3 className="fw-bold">{cert.title}</h3>
            </div>
          </div>
          <p dangerouslySetInnerHTML={{ __html: cert.desc }}></p>
        </div>

        {showReadMore && (
          <div
            style={{
              textAlign: 'center',
              background: expanded ? 'none' : 'linear-gradient(to top, white, transparent)',
              marginTop: '1rem',
              paddingTop: expanded ? '0.5rem' : '2rem',
              position: expanded ? 'static' : 'absolute',
              bottom: 0,
              left: 0,
              right: 0,
            }}
          >
            <IconButton onClick={() => setExpanded(!expanded)}>
              {expanded ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            </IconButton>
          </div>
        )}
      </div>
    </div>
  );
};


export const Certifications = () => {

  const [certification, setCertification] = useState(null);

  const { lang } = useParams();
  const { services: {TranslationsService} } = useContext(AppContext);

  const pageTitle = `${TranslationsService.labels('our_certifications')} | ${TranslationsService.getMainInfoCompany('name')}`;
  const pageDescription = TranslationsService.labels('hero_sections.certifications.text');
  const pageUrl = `https://www.sydea.com/${lang}/about/our-certifications`;

  const webPageSchema = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    name: TranslationsService.labels('our_certifications'),
    description: pageDescription,
    url: pageUrl
  };

  const breadcrumbSchema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      { "@type": "ListItem", position: 1, name: "Home", item: `https://www.sydea.com/${lang}` },
      { "@type": "ListItem", position: 2, name: TranslationsService.labels(`menu.about.label`), item: `https://www.sydea.com/${lang}/about` },
      { "@type": "ListItem", position: 3, name: TranslationsService.labels('our_certifications'), item: pageUrl }
    ]
  };

  const certificationsItemListSchema = certification ? {
    "@context": "https://schema.org",
    "@type": "ItemList",
    name: TranslationsService.labels('our_certifications'),
    itemListElement: Object.values(certification)
      .flat()
      .map((cert, i) => ({
        "@type": "ListItem",
        position: i + 1,
        item: {
          "@type": "EducationalOccupationalCredential",
          name: cert.title,
          image: cert.logo
        }
      }))
  } : null;

  useEffect(() => {
    setCertification(TranslationsService.labels('certifications'));
  }, [TranslationsService]);

  return (
    <div className="section-home light">
      <SeoHelmet
        title={pageTitle}
        description={pageDescription}
        image={TranslationsService.labels('hero_sections.certifications.img_path')}
        schema={certificationsItemListSchema ? [webPageSchema, breadcrumbSchema, certificationsItemListSchema] : [webPageSchema, breadcrumbSchema]}
      />
      <PageHero
        bgImage={TranslationsService.labels('hero_sections.certifications.img_path')}
        breadcrumb={[
           { label: TranslationsService.labels(`menu.about.label`), path: 'about' }
        ]}
        title={TranslationsService.labels(`our_certifications`)}
        subtitle={TranslationsService.labels(`hero_sections.certifications.text`)}
      />

      <div className='p-3'>
        <div className='container-fluid'>
          <div className='row'>
          {certification && Object.entries(certification).map(([category, certList], i) => (
            <React.Fragment key={i}>
              <div className="col-12">
                <h3 className="text-capitalize fw-bold mb-3">{category.replace('-',' ')}</h3>
              </div>
              {certList.map((cert, j) => (
                cert.show_desc ?
                (
                   <CertificationCard keyId={`${i}-${j}`} cert={cert} key={j}/>
                )
                :
                (
                <div key={`${i}-${j}`} className='p-3 d-flex align-items-center justify-content-center text-center box-cert'>
                  <img src={cert.logo} style={{display: "flex", width: "100%", height: "auto", maxWidth:'150px'}} alt={cert.altImg} />
                  <h3 className="text-desc-cert">{cert.title}</h3>
                </div>
                )
              ))}
            </React.Fragment>
          ))}
          </div>
        </div>
      </div>

    </div>
    
  );
};

